import { __decorate } from 'tslib';
import * as i0 from '@angular/core';
import { EventEmitter, ElementRef, Component, Inject, Input, Output, HostListener, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FadvBaseComponent, Forward, Track, FadvCommonModule } from '@fa-switch-sharedservices/ng-elements/common';
import '@fa-switch-sharedservices/web-elements/components/uploader/uploader';
import '@fa-switch-sharedservices/web-elements/components/uploader/uploader-bar';
import { FadvBoxModule } from '@fa-switch-sharedservices/ng-elements/fadv-box';
import { FadvButtonModule } from '@fa-switch-sharedservices/ng-elements/fadv-button';
import { FadvIconModule } from '@fa-switch-sharedservices/ng-elements/fadv-icon';
import { FadvProgressBarModule } from '@fa-switch-sharedservices/ng-elements/fadv-progress-bar';
import { FadvTypographyModule } from '@fa-switch-sharedservices/ng-elements/fadv-typography';

class FadvUploaderBarComponent extends FadvBaseComponent {
    constructor(el) {
        super(el);
        this.uploadInitialized = new EventEmitter();
        this.uploadRetried = new EventEmitter();
        this.uploadCancelled = new EventEmitter();
        this.uploadCompleted = new EventEmitter();
        this.uploadFailed = new EventEmitter();
    }
    _handleUploadRetried(event) {
        this.uploadRetried.emit(event.detail.filename);
    }
    _handleUploadCancelled(event) {
        this.uploadCancelled.emit(event.detail.filename);
    }
    _handleUploadCompleted(event) {
        this.uploadCompleted.emit(event.detail.filename);
    }
    _handleUploadFailed(event) {
        this.uploadFailed.emit(event.detail.filename);
    }
    _handleUploadInitialized(event) {
        this.uploadInitialized.emit(event.detail.file);
    }
}
FadvUploaderBarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvUploaderBarComponent, deps: [{ token: ElementRef }], target: i0.ɵɵFactoryTarget.Component });
FadvUploaderBarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: FadvUploaderBarComponent, selector: "fadv-uploader-bar", inputs: { file: "file", status: "status", progress: "progress" }, outputs: { uploadInitialized: "uploadInitialized", uploadRetried: "uploadRetried", uploadCancelled: "uploadCancelled", uploadCompleted: "uploadCompleted", uploadFailed: "uploadFailed" }, host: { listeners: { "fadv-upload-retried": "_handleUploadRetried($event)", "fadv-upload-cancelled": "_handleUploadCancelled($event)", "fadv-upload-completed": "_handleUploadCompleted($event)", "fadv-upload-failed": "_handleUploadFailed($event)", "fadv-upload-initialized": "_handleUploadInitialized($event)" } }, usesInheritance: true, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
__decorate([
    Forward()
], FadvUploaderBarComponent.prototype, "file", void 0);
__decorate([
    Forward()
], FadvUploaderBarComponent.prototype, "status", void 0);
__decorate([
    Forward()
], FadvUploaderBarComponent.prototype, "progress", void 0);
__decorate([
    Track()
], FadvUploaderBarComponent.prototype, "uploadInitialized", void 0);
__decorate([
    Track()
], FadvUploaderBarComponent.prototype, "uploadRetried", void 0);
__decorate([
    Track()
], FadvUploaderBarComponent.prototype, "uploadCancelled", void 0);
__decorate([
    Track()
], FadvUploaderBarComponent.prototype, "uploadCompleted", void 0);
__decorate([
    Track()
], FadvUploaderBarComponent.prototype, "uploadFailed", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvUploaderBarComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fadv-uploader-bar',
                    template: '<ng-content></ng-content>',
                }]
        }], ctorParameters: function () {
        return [{ type: i0.ElementRef, decorators: [{
                        type: Inject,
                        args: [ElementRef]
                    }] }];
    }, propDecorators: { file: [{
                type: Input
            }], status: [{
                type: Input
            }], progress: [{
                type: Input
            }], uploadInitialized: [{
                type: Output
            }], uploadRetried: [{
                type: Output
            }], uploadCancelled: [{
                type: Output
            }], uploadCompleted: [{
                type: Output
            }], uploadFailed: [{
                type: Output
            }], _handleUploadRetried: [{
                type: HostListener,
                args: ['fadv-upload-retried', ['$event']]
            }], _handleUploadCancelled: [{
                type: HostListener,
                args: ['fadv-upload-cancelled', ['$event']]
            }], _handleUploadCompleted: [{
                type: HostListener,
                args: ['fadv-upload-completed', ['$event']]
            }], _handleUploadFailed: [{
                type: HostListener,
                args: ['fadv-upload-failed', ['$event']]
            }], _handleUploadInitialized: [{
                type: HostListener,
                args: ['fadv-upload-initialized', ['$event']]
            }] } });

class FadvUploaderComponent extends FadvBaseComponent {
    constructor(el) {
        super(el);
        this.acceptsExtensions = [];
        this.acceptsTypes = [];
        this.allowDuplicates = false;
        this.dropped = new EventEmitter();
        this.selected = new EventEmitter();
        this.filesAdded = new EventEmitter();
    }
    get files() {
        return this.elementRef.nativeElement.files;
    }
    removeFile(index) {
        this.elementRef.nativeElement.removeFile(index);
    }
    _handleDropped() {
        this.dropped.emit();
    }
    _handleSelected() {
        this.selected.emit();
    }
    _handleFilesAdded(event) {
        this.filesAdded.emit(event.detail.files);
    }
}
FadvUploaderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvUploaderComponent, deps: [{ token: ElementRef }], target: i0.ɵɵFactoryTarget.Component });
FadvUploaderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: FadvUploaderComponent, selector: "fadv-uploader", inputs: { acceptsExtensions: "acceptsExtensions", acceptsTypes: "acceptsTypes", maxSize: "maxSize", allowDuplicates: "allowDuplicates" }, outputs: { dropped: "dropped", selected: "selected", filesAdded: "filesAdded" }, host: { listeners: { "fadv-file-dropped": "_handleDropped($event)", "fadv-file-selected": "_handleSelected($event)", "fadv-files-added": "_handleFilesAdded($event)" } }, usesInheritance: true, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
__decorate([
    Forward()
], FadvUploaderComponent.prototype, "acceptsExtensions", void 0);
__decorate([
    Forward()
], FadvUploaderComponent.prototype, "acceptsTypes", void 0);
__decorate([
    Forward()
], FadvUploaderComponent.prototype, "maxSize", void 0);
__decorate([
    Forward()
], FadvUploaderComponent.prototype, "allowDuplicates", void 0);
__decorate([
    Track()
], FadvUploaderComponent.prototype, "dropped", void 0);
__decorate([
    Track()
], FadvUploaderComponent.prototype, "selected", void 0);
__decorate([
    Track()
], FadvUploaderComponent.prototype, "filesAdded", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvUploaderComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fadv-uploader',
                    template: '<ng-content></ng-content>',
                }]
        }], ctorParameters: function () {
        return [{ type: i0.ElementRef, decorators: [{
                        type: Inject,
                        args: [ElementRef]
                    }] }];
    }, propDecorators: { acceptsExtensions: [{
                type: Input
            }], acceptsTypes: [{
                type: Input
            }], maxSize: [{
                type: Input
            }], allowDuplicates: [{
                type: Input
            }], dropped: [{
                type: Output
            }], selected: [{
                type: Output
            }], filesAdded: [{
                type: Output
            }], _handleDropped: [{
                type: HostListener,
                args: ['fadv-file-dropped', ['$event']]
            }], _handleSelected: [{
                type: HostListener,
                args: ['fadv-file-selected', ['$event']]
            }], _handleFilesAdded: [{
                type: HostListener,
                args: ['fadv-files-added', ['$event']]
            }] } });

class FadvUploaderModule {
}
FadvUploaderModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvUploaderModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FadvUploaderModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: FadvUploaderModule, declarations: [FadvUploaderComponent, FadvUploaderBarComponent], imports: [FadvCommonModule, FadvTypographyModule, FadvButtonModule, FadvIconModule, FadvBoxModule, FadvProgressBarModule], exports: [FadvUploaderComponent, FadvUploaderBarComponent] });
FadvUploaderModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvUploaderModule, imports: [FadvCommonModule, FadvTypographyModule, FadvButtonModule, FadvIconModule, FadvBoxModule, FadvProgressBarModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvUploaderModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FadvUploaderComponent, FadvUploaderBarComponent],
                    imports: [FadvCommonModule, FadvTypographyModule, FadvButtonModule, FadvIconModule, FadvBoxModule, FadvProgressBarModule],
                    exports: [FadvUploaderComponent, FadvUploaderBarComponent],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { FadvUploaderBarComponent, FadvUploaderComponent, FadvUploaderModule };
